export default __webpack_public_path__ + "static/media/Group7559.471618f9.png";